import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import Month from "./Month";

class CalendarPreview extends Component {
    render() {
        return (
            <Draggable>
              <div className="CalendarPreview">
                <Month styling={this.props.calendar} />
              </div>
            </Draggable>
        );
    }
}

CalendarPreview.propTypes = {
    title: PropTypes.object,
    subtitle: PropTypes.object,
    defaultLink: PropTypes.object,
    largePrice: PropTypes.object
};

const mapStateToProps = state => {
    return { ...state.app.data.theme.calendar, ...state.theme.calendar };
};

export default connect(mapStateToProps)(CalendarPreview);



// WEBPACK FOOTER //
// ./src/components/pages/theme/calendar/Preview.js